interface IRendererProps {
	document: any;
	contentId: string;
	contentType?: string;
}

export const convertRendererProps = (
	isLegacyRenderer: boolean,
	rendererProps: IRendererProps,
):
	| IRendererProps
	| {
			adf: any;
			objectId: string;
			contentType: string | undefined;
	  } => {
	if (!isLegacyRenderer) return rendererProps;

	return {
		adf: rendererProps.document,
		objectId: rendererProps.contentId,
		contentType: rendererProps.contentType,
	};
};

export const getMacroId = (node: any): any => node?.parameters?.macroMetadata?.macroId?.value;
